import { render, staticRenderFns } from "./PercentualParticipacao.vue?vue&type=template&id=6436f434&scoped=true"
import script from "./PercentualParticipacao.vue?vue&type=script&lang=js"
export * from "./PercentualParticipacao.vue?vue&type=script&lang=js"
import style0 from "./PercentualParticipacao.vue?vue&type=style&index=0&id=6436f434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436f434",
  null
  
)

export default component.exports